export default __webpack_public_path__ + "static/media/Anarkata.45248ea8.pdf";